import { useSelector } from "react-redux";

import { ButtonLink, Modal, Stack } from "@seneca/senekit";

import PremiumTag from "features/common/components/PremiumTag";
import { linkToPremiumUpgradeHelp } from "features/dashboard/links";
import { useIsPlurallApp } from "features/plurall";
import { getHelpLinkRegionCode } from "features/regions/selectors";
import { SectionImageCircled } from "features/subscriptions/features/what-is-premium/features/image";
import { ROUTES } from "routing/routes";

import SectionUpgradeMessage from "../SectionUpgradeMessage";

export type Props = {
  upgradeToGetAccessTo?: string;
  onBackClick?: () => void;
  message?: string;
  image?: string;
  linkToUpgrade?: string;
};

export default function MustUpgradePassMessageModal(props: Props) {
  const {
    upgradeToGetAccessTo = "this course",
    message,
    image,
    linkToUpgrade,
    onBackClick
  } = props;

  const isPlurallApp = useIsPlurallApp();
  const helpLinkRegionCode = useSelector(getHelpLinkRegionCode);

  return (
    <Modal onCloseClick={onBackClick}>
      <Stack space="xxlarge">
        <PremiumTag />
        <Stack space="xxlarge" align="center">
          {image && <SectionImageCircled image={image} />}
          <SectionUpgradeMessage
            message={message}
            upgradeToGetAccessTo={upgradeToGetAccessTo}
          />
          <ButtonLink
            newTab={!linkToUpgrade}
            width={["100%", "35%"]}
            to={
              isPlurallApp
                ? ROUTES.WHAT_IS_PREMIUM.PARENT.buildPath({})
                : linkToUpgrade || linkToPremiumUpgradeHelp(helpLinkRegionCode)
            }
          >
            Upgrade package
          </ButtonLink>
        </Stack>
      </Stack>
    </Modal>
  );
}
